module.exports = __webpack_public_path__ + "img/footer-bg-image.5c98352a.svg";